// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const formatHashtagInput = (hastags: string[]) =>
  hastags.map((hashtag) => ({ name: hashtag }));
